export default __webpack_public_path__ + "static/studio-slider-7-8f03a91badba982568362c96b7d9bd74.png";